import React from 'react';
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MantineProvider, ColorSchemeProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { useLocalStorage } from '@mantine/hooks';

import { useLoginContext } from "./context/loginContext";
import { useLoginContextSU } from "./context/loginContextSU";

import SuperUserHome from "./pages/superuser/SuperUserHome";
import MasterOW from "./pages/owner/MasterOW";
import ProjectOW from "./pages/owner/ProjectOW";
import AccountOW from "./pages/owner/AccountOW";

import AccountTK from "./pages/teknisiKoordinator/AccountTK";
import ProjectTK from "./pages/teknisiKoordinator/ProjectTK";
import MasterTK from "./pages/teknisiKoordinator/MasterTK";

import AccountTS from "./pages/teknisiStaf/AccountTS";
import ProjectTS from "./pages/teknisiStaf/ProjectTS";
import MasterTS from "./pages/teknisiStaf/MasterTS";

import AccountAS from "./pages/adminStaf/AccountAS";
import ProjectAS from "./pages/adminStaf/ProjectAS";
import MasterAS from "./pages/adminStaf/MasterAS";

import ForgotPasswordSecondStep from "./pages/login/ForgotPasswordSecondStep";
import ForgotPasswordSecondStepSU from "./pages/superuser/ForgotPasswordSecondStepSU";

import MQT from "./components/dev/MQT";
import DevIndex from "./pages/dev/DevIndex";

import SuperUserRoute from "./routes/SuperUserRoute";
import LoginRouteSU from "./routes/LoginRouteSU";

import LoginRoute from "./routes/LoginRoute";
import OwnerRoute from "./routes/OwnerRoute";
import TKRoute from "./routes/TKRoute";
import TSRoute from "./routes/TSRoute";
import ASRoute from "./routes/ASRoute";

import {
    utils, menuList, BE_API_AUTH, BE_API_SU_ONE, role,
    DOMAIN_NAME, DOMAIN_NAME_HOST, ROOT_BASE_URL, DOMAIN_FE, BE_API_ONE
} from "./utils/globalVariables";

/*
1. ok -- scroll di drawer diganti dengan native
2. ok -- tombol warna merah diganti warna biru
3. ok -- di garansi pengajuan, project tag klo di uncheck jd error (ga muncul no project / no nota nya)
5. ok -- item stock yang tagged tp ga punya client/project kyknya disebabkan krn wkt garansi, lalu dibatalkan (otomatis masuk ke master stock)
6. ok -- di tambah stok tambahan, tambahin cta filter tagged only for this client/project
8. ok -- periksa be, stock yg akan dikembalikan ke ms_stock => Jika aslinya tagged & client/projectnya ditag, tagged nya hrs berubah jd claimed.
9. ok -- tambah payload stock status di batalkan garansi step 1 (batalin lagi)

10. ok -- di BE garansi_terima_item_positioning, periksa fungsi ini (apakah sesederhana ini ?) :
    function item_status($tagged_client_id, $tagged_project_id, $stock_status_list)
    {
      return ($tagged_client_id || $tagged_project_id) ? $stock_status_list->tagged->value : $stock_status_list->claimed->value;
    }

11. ok -- Di invoice dan tanda bayar, kasih no nota, telepon
12. ok -- Buat PDF tanda terima
13. ok -- Buat tanda tangan digital

14. prevent file signature nya error
15. ok -- bikin filter di klaim garansi (ada 2)

17. Perlu tanggal cetak di document:
    1. ok -- di tanda terima --> tanggal nota saja (tanggal masuk)
    2. ok-- di inv --> tanggal nota, tanggal inv (custom - tapi jika mau cetak ulang hrs munculin tanggal terbit pertama dan bs custom)
    3. ok -- di bukti bayar --> tanggal nota dan tanggal bayar (di step selesai hrsnya blm ada, baru muncul setelah pembayaran/pengambilan)

    4. ok -- INVBBComponent di StepNotaDibatalkan.js hrs dihandle?

20. ok -- barang_nama sebagai indikator pernah di servis, haruskah pakai eksak(BINARY di BE)? sepertinya harus, ada yg sdh ada yg blm. Lengkapi!

21. ok -- di step sudah diambil, tambahkan info (kolom jenis maintenance, servis atau maintenance), tambah filter tanggal ambil, jenis servis 
23. ok -- tanggal reminder itu berdasarkan tanggal ambil atau tanggal selesai? (tanggal ambil)
25. ok -- data di stock item yg versi table, blm lengkap, blm ada data tagging nya 
26. Hilangkan id stock di card ms stock
27. ok -- indikator servis dan maintetnance dan both sebaiknya bukan pas ngambil, tapi pas teknisi mau next step ke qc, disitu teknisi yg isi ini jenisnya apa. karena klo admin yg ngisi pasti bingung.
28. is_active dari setiap table masih blm digunakan secara optimal, masih useless !

29. Teknisi harusnya ga bisa ubah data nota? kyknya boleh
30. catatan2 atw keterangan yg sifatnya ga bisa diedit oleh teknisi sebaiknya tidak dalam bentuk input/textarea, tp dalam bentuk text biar klo panjang bacanya enak.

31. di qc jika dibuka oleh kepala teknisi/owner, jika sudah di rollback ke pengerjaan, tapi masih kebuka di drawer qc dan ada tombol CTA submit dan ke pengerjaan, harusnya ga muncul klo sudah mundur step (data tidak ada)

32. di step sudah diambil, di akun admin harus ada data pembayaran yang dikunci, bahaya juga kalau tidak dikunci, bisa diubah2 (celah). 
-------------
13.22 lepas charger 100%
15.22 masih bertahan 25%

*/

const App = () => {

    const mountedRef = React.useRef(true);

    const { loginContext, handleSetLoginContext } = useLoginContext();
    const { loginContextSU, handleSetLoginContextSU } = useLoginContextSU();

    React.useEffect(() => {
        if (loginContext) {
            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext ? loginContext.syswebapp : null);

            axios({
                method: 'post',
                url: BE_API_AUTH + '/authentication_checker',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                if (response.data.flag_status === 'isset') {
                    if (response.data.data.flag_status === 'isset') {
                        if (JSON.stringify(loginContext.syswebapp) !== JSON.stringify(response.data.data.data.syswebapp)) {
                            handleSetLoginContext(response.data.data.data);
                        }
                    }

                    if (response.data.data.flag_status === 'no-data') {
                        handleSetLoginContext(null);
                    }
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;
                console.log(error.message);
            })
        }
    }, [loginContext, handleSetLoginContext]);

    React.useEffect(() => {
        if (loginContextSU) {
            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContextSU ? loginContextSU.syswebapp : null);

            axios({
                method: 'post',
                url: BE_API_SU_ONE + '/authentication_checker_su',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                if (response.data.flag_status === 'isset') {
                    if (JSON.stringify(loginContextSU.syswebapp) !== JSON.stringify(response.data.data.syswebapp)) {
                        handleSetLoginContextSU(response.data.data);
                    }
                }

                if (response.data.flag_status === 'no-data') {
                    handleSetLoginContextSU(null);
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContextSU(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContextSU(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;
                console.log(error.message);
            })
        }
    }, [loginContextSU, handleSetLoginContextSU]);

    const [colorSkema, setColorScheme] = useLocalStorage({
        key: utils.localStorageName.theme,
        defaultValue: utils.theme.light.slug,
        getInitialValueInEffect: false,
    });

    return (
        <ColorSchemeProvider
            colorScheme={colorSkema}
            toggleColorScheme={(value) => {
                setColorScheme(value || (colorSkema === utils.theme.dark.slug ? utils.theme.light.slug : utils.theme.dark.slug));
            }}
        >
            <MantineProvider
                theme={{
                    colorScheme: colorSkema,
                    colors: {
                        // Add your color
                        tosca: ['#e8faf8', '#d2f5f1', '#bbefeb', '#a4eae4', '#8ee5dd', '#77e0d6', '#61dbcf', '#4ad6c8', '#33d0c2', '#2bbdaf'],

                        // Replace default theme color
                        // dark.6 from #25262B changes to #212226
                        // dark: ['#C1C2C5', '#A6A7AB', '#909296', '#5C5F66', '#373A40', '#2C2E33', '#212226', '#1A1B1E', '#141517', '#101113'],
                    },

                    activeStyles: { transform: 'none' },

                    components: {
                        InputWrapper: {
                            styles: () => ({
                                label: {
                                    marginBottom: '.5rem'
                                },
                                description: {
                                    marginBottom: '.25rem'
                                }
                            }),
                        },
                        Notification: {
                            styles: (theme) => ({
                                root: {
                                    border: theme.colorScheme === utils.theme.light.slug ? `1px solid ${theme.colors.gray[1]}` : `1px solid ${theme.colors.gray[9]}`
                                }
                            })
                        }
                    },
                }}
                withGlobalStyles
                withNormalizeCSS
            >
                <Notifications
                    position="bottom-left"
                // containerWidth={325}
                />

                <MQT
                    stateIsRight={false}
                    stateIsBottom={true}
                />

                {/* <div>
                    DOMAIN_NAME: {DOMAIN_NAME}
                </div>

                <div>
                    DOMAIN_NAME_HOST: {DOMAIN_NAME_HOST}
                </div>

                <div>
                    ROOT_BASE_URL: {ROOT_BASE_URL}
                </div>

                <div>
                    DOMAIN_FE: {DOMAIN_FE}
                </div>

                <div>
                    BE_API_ONE: {BE_API_ONE}
                </div> */}

                <BrowserRouter>

                    <Routes>
                        <Route path='/' element={<LoginRoute />} />

                        <Route path='superuser' element={<LoginRouteSU />} />

                        <Route path='*' element={<div>404</div>} />

                        <Route path={utils.linkVerifikasiSlug} element={<ForgotPasswordSecondStep />}>
                            <Route path={`:kode`} element={<ForgotPasswordSecondStep />} />
                        </Route>

                        {/* Route SU */}
                        <Route
                            path={`su/:tab`}
                            element={<SuperUserRoute stateComponent={<SuperUserHome />} />}
                        />

                        <Route path={utils.linkVerifikasiSlugSU} element={<ForgotPasswordSecondStepSU />}>
                            <Route path={`:kode`} element={<ForgotPasswordSecondStepSU />} />
                        </Route>

                        {/* Route Owner */}
                        <Route
                            path={`${role.owner.subLevel.owner.slugLink}/master/:subMenu/:tab?`}
                            element={<OwnerRoute stateComponent={<MasterOW />} />}
                        />

                        <Route
                            path={`${role.owner.subLevel.owner.slugLink}/project/:subMenu/:tab?/:URI1?/:URI2?/:URI3?`}
                            element={<OwnerRoute stateComponent={<ProjectOW />} />}
                        />

                        <Route
                            path={`${role.owner.subLevel.owner.slugLink}/account/:subMenu/:tab?/:URI1?`}
                            element={<OwnerRoute stateComponent={<AccountOW />} />}
                        />

                        {/* Route Teknisi Koordinator */}
                        <Route
                            path={`${role.teknisi.subLevel.teknisi_kepala.slugLink}/master/:subMenu/:tab?`}
                            element={<TKRoute stateComponent={<MasterTK />} />}
                        />

                        <Route
                            // path={`${role.teknisi.subLevel.teknisi_kepala.slugLink}/project/:subMenu/:tab?/:URI1?`}
                            path={`${role.teknisi.subLevel.teknisi_kepala.slugLink}/project/:subMenu/:tab?/:URI1?/:URI2?/:URI3?`}
                            element={<TKRoute stateComponent={<ProjectTK />} />}
                        />

                        <Route
                            path={`${role.teknisi.subLevel.teknisi_kepala.slugLink}/account/:subMenu/:tab?/:URI1?`}
                            element={<TKRoute stateComponent={<AccountTK />} />}
                        />

                        {/* Route Teknisi Staf */}
                        <Route
                            path={`${role.teknisi.subLevel.teknisi_staf.slugLink}/master/:subMenu/:tab?`}
                            element={<TSRoute stateComponent={<MasterTS />} />}
                        />

                        <Route
                            // path={`${role.teknisi.subLevel.teknisi_staf.slugLink}/project/:subMenu/:tab?/:URI1?`}
                            path={`${role.teknisi.subLevel.teknisi_staf.slugLink}/project/:subMenu/:tab?/:URI1?/:URI2?/:URI3?`}
                            element={<TSRoute stateComponent={<ProjectTS />} />}
                        />

                        <Route
                            path={`${role.teknisi.subLevel.teknisi_staf.slugLink}/account/:subMenu/:tab?/:URI1?`}
                            element={<TSRoute stateComponent={<AccountTS />} />}
                        />

                        {/* Route Admin Staf */}
                        <Route
                            path={`${role.admin.subLevel.admin_staf.slugLink}/master/:subMenu/:tab?`}
                            element={<ASRoute stateComponent={<MasterAS />} />}
                        />

                        <Route
                            // path={`${role.admin.subLevel.admin_staf.slugLink}/project/:subMenu/:tab?/:URI1?`}
                            path={`${role.admin.subLevel.admin_staf.slugLink}/project/:subMenu/:tab?/:URI1?/:URI2?/:URI3?`}
                            element={<ASRoute stateComponent={<ProjectAS />} />}
                        />

                        <Route
                            path={`${role.admin.subLevel.admin_staf.slugLink}/account/:subMenu/:tab?/:URI1?`}
                            element={<ASRoute stateComponent={<AccountAS />} />}
                        />

                        {/* Dev */}
                        <Route
                            path={`${role.owner.subLevel.owner.slugLink}/${menuList.dev.slug}/:subMenu/:tab?`}
                            element={<OwnerRoute stateComponent={<DevIndex />} />}
                        />

                    </Routes>
                </BrowserRouter>

            </MantineProvider>
        </ColorSchemeProvider>
    );
}

export default App;
